import React from "react";
import { BrowserRouter as Router } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import RoutesContainer from "./components/routesContainer";
import ScrollToTop from "./components/scrollToTop";
import "./i18n"

const App = () => {
  return (
    <HelmetProvider>
      <Router>
          <ScrollToTop />
          <RoutesContainer />
      </Router>
    </HelmetProvider>
  );
};

export default App;
